var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E2FFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C18.0953 2 21.0891 3.10446 23.4428 5.11472C25.7965 7.12499 27.3557 9.90912 27.8399 12.9664C28.3242 16.0236 27.7016 19.1533 26.0843 21.7925C24.467 24.4317 21.9611 26.4072 19.0172 27.3637C16.0734 28.3202 12.8848 28.195 10.0251 27.0104C7.16539 25.8259 4.82217 23.6598 3.41691 20.9019C2.01166 18.1439 1.6366 14.975 2.35919 11.9652C3.08179 8.95539 4.85461 6.30217 7.3588 4.48278L15 15V2Z",
    fill: "#46B873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.0fa8e681f9c92811f3da59fb37ea35fe.svg";
export { ForwardRef as ReactComponent };